import React from "react";
import { Breadcrumb, Button, Card, CardBody, CardFooter, Col, Container, Row, Spinner } from "reactstrap";
import FeatherIcon from 'feather-icons-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { privacyPolicyUser } from "../../slices/thunks";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selector = createSelector(
    state => state.Users,
    result => ({
      loading: result.isUpdated,
    })
  );

  const { loading } = useSelector(selector);

  const handleAccept = async () => {
    dispatch(privacyPolicyUser());
    if (!loading) {
      let authUser = JSON.parse(localStorage.getItem('authUser'));
      authUser.privacy_policy = true;
      localStorage.setItem('authUser', JSON.stringify(authUser));
      navigate('/dashboard');
    }
  };

  const handleLogout = () => {
    window.location.href = `${process.env.PUBLIC_URL}/logout`;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col className="col-lg-10">
              <Card>
                <div className="bg-info-subtle position-relative">
                  <CardBody className="card-body p-5">
                    <div className="text-center">
                      <h3>Política de Privacidad</h3>
                      <p className="mb-0 text-muted">
                        Última actualización: 24 de Julio de 2024
                      </p>
                    </div>
                  </CardBody>
                  <div className="shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="1440"
                      height="60"
                      preserveAspectRatio="none"
                      viewBox="0 0 1440 60"
                    >
                      <g mask='url("#SvgjsMask1001")' fill="none">
                        <path
                          d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                          style={{ fill: "var(--vz-secondary-bg)" }}
                        ></path>
                      </g>
                      <defs>
                        <mask id="SvgjsMask1001">
                          <rect width="1440" height="60" fill="#ffffff"></rect>
                        </mask>
                      </defs>
                    </svg>
                  </div>
                </div>
                <CardBody className="p-4">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <FeatherIcon icon="check-circle" className={"text-primary icon-dual-primary icon-xs"} />
                    </div>
                    <div className="flex-grow-1">
                      <h5>Política de Privacidad para SPED</h5>
                      <p className="text-muted">
                        En SPED, accesible desde SPED.cl, una de nuestras principales prioridades es la privacidad de nuestros visitantes. Este documento de Política de Privacidad contiene los tipos de información que se recopilan y registran en SPED y cómo los usamos.
                      </p>
                      <p className="text-muted">
                        Si tienes preguntas adicionales o necesitas más información sobre nuestra Política de Privacidad, no dudes en contactarnos por correo electrónico en hola@SPED.cl.
                      </p>
                      <p className="text-muted">
                        Esta política de privacidad se aplica solo a nuestras actividades en línea y es válida para los visitantes de nuestro sitio web con respecto a la información que compartieron y/o recopilaron en SPED. Esta política no se aplica a ninguna información recopilada fuera de línea o a través de canales distintos de este sitio web.
                      </p>
                      <p className="text-muted">Cómo usamos tu información:</p>
                      <ul className="text-muted">
                        <li>
                          <p>
                            Utilizamos la información personal que nos proporcionas para responder a tus consultas, brindarte información solicitada y enviar comunicaciones relacionadas con nuestros servicios.
                          </p>
                        </li>
                        <li>
                          <p>
                            No compartiremos tu información personal con terceros no afiliados, excepto cuando sea necesario para cumplir con tus solicitudes o cumplir con la ley.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <FeatherIcon icon="check-circle" className={"text-primary icon-dual-primary icon-xs"} />
                    </div>
                    <div className="flex-grow-1">
                      <h5>Recopilación Automática de Datos</h5>
                      <p className="text-muted">
                        Utilizamos herramientas de análisis para recopilar automáticamente información sobre cómo interactúas con nuestra página web. Esto puede incluir tu dirección IP, tipo de navegador, páginas visitadas y otros datos similares. Esta información se usa exclusivamente para el funcionamiento y mejora del sistema y no se trata con otros fines.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <FeatherIcon icon="check-circle" className={"text-primary icon-dual-primary icon-xs"} />
                    </div>
                    <div className="flex-grow-1">
                      <h5>Privacidad de los Niños</h5>
                      <p className="text-muted">
                        Nuestra página web no está dirigida a personas menores de 13 años. No recopilamos de manera intencional información de identificación personal de niños menores de 13 años. Si eres padre/madre o tutor y tienes conocimiento de que tu hijo nos ha proporcionado información personal, contáctanos y tomaremos las medidas necesarias para eliminar dicha información de nuestros registros.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <FeatherIcon icon="check-circle" className={"text-primary icon-dual-primary icon-xs"} />
                    </div>
                    <div className="flex-grow-1">
                      <h5>Seguridad de la Información</h5>
                      <p className="text-muted">
                        Implementamos medidas de seguridad razonables para proteger la información personal que recopilamos. Sin embargo, ten en cuenta que ninguna transmisión de datos por Internet puede garantizarse como segura.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <FeatherIcon icon="check-circle" className={"text-primary icon-dual-primary icon-xs"} />
                    </div>
                    <div className="flex-grow-1">
                      <h5>Cambios en la Política de Privacidad</h5>
                      <p className="text-muted">
                        Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Te recomendamos revisar periódicamente esta página para estar informado sobre los cambios. Al utilizar nuestra página web, aceptas las condiciones establecidas en esta Política de Privacidad.
                      </p>
                      <p className="text-muted">
                        Si tienes alguna pregunta o sugerencia sobre esta Política de Privacidad, no dudes en contactarnos en <a href="mailto:hola@SPED.cl">hola@SPED.cl</a>.
                      </p>
                    </div>
                  </div>
                </CardBody>



                <CardFooter>

                  <div className="hstack gap-3">
                    <Button
                      onClick={handleLogout}
                      color='danger'
                      className='btn-label'>
                      <i className={`${Icons.check2} label-icon align-middle fs-16 me-2`}></i>
                      No Acepto
                    </Button>

                    <Button
                      disabled={loading}
                      onClick={handleAccept}
                      color='success'
                      className='btn-label ms-auto'
                      type='submit'
                    >
                      {loading ? (<i className='label-icon'><Spinner size='sm' /></i>) : null}
                      <i className={`${Icons.check2} label-icon align-middle fs-16 me-2`}></i>
                      Aceptar
                    </Button>

                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
};

export default PrivacyPolicy;
